// Texto de los valores de un campo de la ficha (actual o solicitado), para la ficha 360 y la bandeja
// del supervisor. Solo presentación: el valor lo guarda y lo aplica el backend.
import type { CampoFicha } from '../api/contratos';
import { NOMBRE_CONDICION, pesos } from '../comun/formato';

export const NOMBRE_CAMPO: Record<CampoFicha, string> = {
  telefono: 'Teléfono',
  email: 'Correo',
  contacto: 'Contacto nuevo',
  direccion: 'Dirección nueva',
  observaciones: 'Observaciones',
  linea_credito: 'Línea de crédito',
  condicion_pago: 'Condición de pago',
  lista_precio: 'Lista de precios',
  vendedor: 'Vendedor',
  estado_comercial: 'Estado comercial',
};

export interface Nombres {
  vendedor: (id: string) => string;
  lista: (id: string) => string;
  comuna: (codigo: string) => string;
}

export function textoValor(campo: CampoFicha, valor: unknown, n: Nombres): string {
  if (valor === null || valor === undefined) return '—';
  const v = valor as Record<string, unknown>;
  switch (campo) {
    case 'telefono':
    case 'email':
      return String(v['valor'] ?? '—');
    case 'observaciones':
      return v['valor'] ? String(v['valor']) : '(sin observaciones)';
    case 'contacto':
      return [v['nombre'], v['cargo']].filter(Boolean).join(' · ');
    case 'direccion':
      return [
        [v['calle'], v['numero'], v['complemento']].filter(Boolean).join(' '),
        v['comunaCodigo'] ? n.comuna(String(v['comunaCodigo'])) : null,
      ]
        .filter(Boolean)
        .join(' · ');
    case 'linea_credito':
      return v['valor'] ? pesos(String(v['valor'])) : 'sin línea';
    case 'condicion_pago': {
      const c = String(v['condicion'] ?? '');
      const plazo = Number(v['plazoDias'] ?? 0);
      return `${NOMBRE_CONDICION[c] ?? c}${plazo ? ` ${plazo} días` : ''}`;
    }
    case 'lista_precio':
      return v['listaPrecioId'] ? n.lista(String(v['listaPrecioId'])) : '—';
    case 'vendedor':
      return v['vendedorId'] ? n.vendedor(String(v['vendedorId'])) : 'sin vendedor';
    case 'estado_comercial':
      return v['bloqueado']
        ? `BLOQUEADO${v['motivo'] ? `: ${String(v['motivo'])}` : ''}`
        : 'Activo';
  }
}
